export default {
  getPerPage: (tab) => {
    return 15;
  },
  getHead: () => {
    return [
      { name: "No.", style: { minWidth: "100px", width: "100px" } },
      { name: "사업장명", key: "field_name" },
      { name: "주소", key: "address" },
      { name: "사업장 연락처", key: "phone" },
      { name: "관리책임자", key: "director_name" },
    ];
  },
  getCol: (index, row, func) => {
    try {
      switch (index) {
        // No.
        case 0:
          return func.no;
        // 사업장명
        case 1:
          return row.field_name || "-";
        // 주소
        case 2:
          return row.address || "-";
        // 사업장 연락처
        case 3:
          return row.phone || "-";
        // 담당자
        case 4:
          return row.director_name || "-";
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
};
